import "./App.css";
import Header from "./components/Header/Header";
import Main from "./components/Main/Main";
import Footer from "./components/Footer/FooterPage";
import PopUp from "./components/Popup/PopUp";
import { Router } from "wouter";

function App() {
	return (
		<Router>
			<div className="min-h-screen w-full font-sans text-slate-200 overflow-x-hidden bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
				{/* Animated background gradient accent */}
				<div className="fixed inset-0 -z-10 bg-gradient-to-r from-amber-500/5 to-amber-500/5 opacity-30 pointer-events-none" />
				
				<PopUp />
				<Header />
				<Main />
				<Footer />
			</div>
		</Router>
	);
}

export default App;


